import { Text } from "@/components/ui/text";
import { EmailAuthLayout } from "./EmailAuthLayout";

export function LoginMagic({ email }: { email: string | undefined }) {
  return (
    <EmailAuthLayout email={email} type="magic-link">
      <Text elementType="p">
        We've sent a sign-in link to{" "}
        {email ? <span className="font-medium">{email}</span> : "your email"}.
        Click the link in the email to instantly sign in.
      </Text>
    </EmailAuthLayout>
  );
}
